module.exports = __webpack_public_path__ + "img/5-Commrisk-Populated-Details-Page.79b7c558.png";